<ng-container [formGroup]="workingPeriodForm">
  <div class="form__item row mb-4">
    <ng-container *ngIf="!this.workingPeriod.isNewStatusContractor">
      <label
        class="col-sm-3 d-flex align-items-center"
        appMarkAsterisk
        [formGroup]="workingPeriodForm"
        [controlName]="'stavka'"
        [touched]="workingPeriod.stavka.touched"
        >Salary stavka</label
      >
      <div class="col-sm-3 form-validation d-flex align-items-center">
        <input
          type="number"
          class="input__basic salary__input"
          formControlName="stavka"
          placeholder=" "
        />
        <app-error-field
          [displayError]="workingPeriod.stavka.hasError('max')"
          [errorMessage]="'Max value = 999999'"
        ></app-error-field>
        <app-error-field
          [displayError]="workingPeriod.stavka.hasError('min')"
          [errorMessage]="
            this.workingPeriod.isNewStatusEmployee
              ? 'The value should be greater than 0'
              : 'The value should be positive'
          "
        ></app-error-field>
      </div>
    </ng-container>

    <div
      class="form-validation d-flex align-items-center"
      [ngClass]="rateClass"
    >
      <label
        class="d-flex align-items-center"
        [ngClass]="rateInputClass"
        appMarkAsterisk
        [formGroup]="workingPeriodForm"
        [controlName]="'rate'"
        [touched]="workingPeriod.rate.touched"
        >Rate per hour</label
      >
      <input
        type="number"
        class="input__basic salary__input__rate"
        formControlName="rate"
        placeholder=" "
      />
      <app-error-field
        [displayError]="workingPeriod.rate.hasError('max')"
        [errorMessage]="'Max value = 999'"
      ></app-error-field>
      <app-error-field
        [displayError]="workingPeriod.rate.hasError('min')"
        [errorMessage]="
          this.workingPeriod.isNewStatusContractor
            ? 'The value should be greater than 0'
            : 'The value should be positive'
        "
      ></app-error-field>
    </div>
  </div>
  <div class="form__item row mb-3">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'startDate'"
      >Start Day</label
    >
    <div class="col-sm-7">
      <app-datepicker
        [iconLeft]="true"
        formControlName="startDate"
      ></app-datepicker>
    </div>
  </div>

  <div class="form__item row mb-3 form-validation">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'projectName'"
      [touched]="workingPeriodForm.get('projectName')!.touched"
      >Project name
    </label>
    <div class="col-sm-7 general_form_input">
      <input
        type="text"
        class="input__basic"
        placeholder=" "
        formControlName="projectName"
      />
      <app-error-field
        [displayError]="
          isFieldInvalid('projectName', workingPeriodForm) &&
          workingPeriodForm.get('projectName')!.hasError('required')
        "
        [errorMessage]="'The field is required'"
      ></app-error-field>
      <app-error-field
        [displayError]="
          workingPeriodForm.get('projectName')!.hasError('maxlength')
        "
        [errorMessage]="'Max field length = 30'"
      ></app-error-field>
    </div>
  </div>

  <div class="form__item row mb-3" *ngIf="isPMAllowToChoose">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'newPM'"
      [touched]="workingPeriodForm.get('newPM')!.touched"
      >Project manager</label
    >
    <div class="col-sm-7">
      <app-dropdown
        ngDefaultControl
        formControlName="newPM"
        [items]="pmOptionsList"
      ></app-dropdown>
    </div>
  </div>

  <div class="form__item row mb-3">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'newLineManager'"
      [touched]="workingPeriodForm.get('newLineManager')!.touched"
      >Line manager</label
    >
    <div class="col-sm-7">
      <app-dropdown
        ngDefaultControl
        formControlName="newLineManager"
        [items]="lmOptionsList"
      ></app-dropdown>
    </div>
  </div>

  <ng-container *ngIf="!isFormer">
    <div class="form__item row mb-3">
      <label
        class="col-sm-3 d-flex align-items-center"
        appMarkAsterisk
        [formGroup]="workingPeriodForm"
        [controlName]="'corporateAccount'"
        [touched]="workingPeriodForm.get('corporateAccount')!.touched"
        >Corporate account</label
      >
      <div class="col-sm-5">
        <app-dropdown
          formControlName="corporateAccount"
          [items]="corporateAccountOptionsList"
          [border]="'classic'"
        ></app-dropdown>
      </div>
    </div>
    <div class="form__item row mb-3">
      <label
        class="col-sm-3 d-flex align-items-center"
        appMarkAsterisk
        [formGroup]="workingPeriodForm"
        [controlName]="'equipment'"
        [touched]="workingPeriodForm.get('equipment')!.touched"
        >Equipment</label
      >
      <div class="col-sm-7">
        <app-dropdown
          formControlName="equipment"
          [items]="equipmentOptionsList"
          [border]="'classic'"
        ></app-dropdown>
      </div>
    </div>
    <div class="form__item row mb-3">
      <label
        class="col-sm-3 d-flex align-items-center"
        appMarkAsterisk
        [formGroup]="workingPeriodForm"
        [controlName]="'location'"
        [touched]="workingPeriodForm.get('location')!.touched"
        >Employee location</label
      >
      <div class="col-sm-3">
        <input
          type="text"
          class="input__basic"
          formControlName="location"
          placeholder=" "
        />
      </div>
    </div>
  </ng-container>

  <div class="form__item row mb-3">
    <label
      class="col-sm-3 d-flex align-items-center"
      appMarkAsterisk
      [formGroup]="workingPeriodForm"
      [controlName]="'comment'"
      [touched]="workingPeriodForm.get('comment')!.touched"
      >Comment</label
    >
    <div class="col-sm-3">
      <textarea
        type="textarea"
        class="input__basic"
        formControlName="comment"
        placeholder=" "
      >
      </textarea>
    </div>
  </div>
</ng-container>
